export enum BudgetType {
    Income = 1,
    Expense = 2
  }